import { type DocumentNode, gql } from '@apollo/client';

const logoutMutation: DocumentNode = gql`
  mutation logout {
    logout {
      success
    }
  }
`;

export default logoutMutation;
